
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/page-builder/[[...slug]]",
      function () {
        return require("private-next-pages/page-builder/[[...slug]].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/page-builder/[[...slug]]"])
      });
    }
  